export enum FontWeightToken {
  fontWeightLight = '300',
  fontWeightRegular = '400',
  fontWeightSemiBold = '600',
  fontWeightBold = '700',
}

export default FontWeightToken

export type TFontWeight =
  | 'fontWeightLight'
  | 'fontWeightRegular'
  | 'fontWeightSemiBold'
  | 'fontWeightBold'
